module.exports = __webpack_public_path__ + "img/image-add.c97709fb.png";